<template>
  <div>
    <div class="py-10" v-if="get_loading">
      <p class="text-center"><i class="el-icon-loading"></i></p>
    </div>
    <div v-if="!get_loading">
      <div class="menu-header">
        <div class="menu-header-check-all">
          <input type="checkbox" v-model="checkAll" @change="handleCheckAllChange" />
        </div>
        <div class="menu-header-filters">
          <el-input
            v-model="filters.name"
            placeholder="Cari nama menu..."
            prefix-icon="el-icon-search"
            size="small"
            clearable
            style="width: 200px; margin-right: 10px;"
          >
          </el-input>
          <el-select
            v-model="filters.category"
            placeholder="Semua Kategori"
            size="small"
            clearable
            style="width: 150px; margin-right: 10px;"
          >
            <el-option label="Semua" value=""></el-option>
            <el-option label="WEB" value="WEB"></el-option>
            <el-option label="MOBILE" value="MOBILE"></el-option>
          </el-select>
        </div>
        <div>
          <el-button size="mini" type="default" icon="el-icon-view" v-if="items.selected.length === 1" @click="showDetailDialog" circle></el-button>
          <el-button size="mini" type="success" icon="el-icon-connection" v-if="items.selected.length === 1" @click="showKelolaDialog" round>Kelola</el-button>
          <!-- <el-button size="mini" type="success" icon="el-icon-connection" v-if="items.selected.length === 1" @click="showSetSubmenuDialog" round>Kelola Submenu</el-button>
          <el-button size="mini" type="info" icon="el-icon-connection" v-if="items.selected.length === 1" @click="showSetRoleDialog" round>Set Role</el-button> -->
          <el-button size="mini" type="primary" icon="el-icon-plus" @click="showTambahDialog" v-if="items.selected.length === 0"  circle></el-button>
          <el-button size="mini" type="warning" icon="el-icon-edit" v-if="items.selected.length === 1" @click="showEditDialog" circle></el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" v-if="items.selected.length > 0" @click="showHapusDialog" circle></el-button>
        </div>
      </div>
      <div class="menu-content" v-for="(item, index) in paginatedMenus" :key="index">
        <div class="menu-zero">
          <input type="checkbox" :value="item" :label="item.id" v-model="items.selected" @change="handleCheckChange" />
        </div>
        <div class="menu-first">
          <img :src="apiHost + '/api' + item.icon" alt="icon" width="50" height="50" />
        </div>
        <div class="menu-second">
          <p class="menu-label leading-none">{{ item.label }}</p>
          <p class="menu-path leading-none">{{ item.path }}</p>
        </div>
        <div class="menu-third">
          <el-tag :type="item.category === 'WEB' ? 'primary' : 'success'" size="small">
            <i :class="item.category == 'WEB' ? 'el-icon-monitor' : 'el-icon-mobile'"></i> {{ item.category }}
          </el-tag>
        </div>
        <div class="menu-fourth">
          <el-tag :type="item.pinSecurity ? 'warning' : 'info'" size="small">
            <i :class="item.pinSecurity ? 'el-icon-lock' : 'el-icon-unlock'"></i> {{ item.pinSecurity ? 'Ya' : 'Tidak' }}
          </el-tag>
        </div>
      </div>
      <div class="menu-footer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
      </div>
    </div>

    <!-- Dialog Kelola (Unified: Submenu + Role) -->
    <el-dialog :visible.sync="dialogs.kelola" width="850px" top="5vh" custom-class="kelola-dialog">
      <div slot="title" class="kelola-dialog-header">
        <div>
          <h3 class="kelola-title">Kelola Menu</h3>
          <p class="kelola-subtitle">Atur submenu dan role akses</p>
        </div>
      </div>
      
      <div v-if="items.selected.length === 1" class="kelola-content">
        <!-- Parent Menu Info -->
        <div class="kelola-menu-card">
          <div class="kelola-menu-icon">
            <img :src="apiHost + '/api' + items.selected[0].icon" alt="icon" />
          </div>
          <div class="kelola-menu-details">
            <h4 class="kelola-menu-label">{{ items.selected[0].label }}</h4>
            <p class="kelola-menu-path">{{ items.selected[0].path }}</p>
          </div>
          <div class="kelola-menu-tags">
            <el-tag :type="items.selected[0].category === 'WEB' ? 'primary' : 'success'" size="small">
              <i :class="items.selected[0].category == 'WEB' ? 'el-icon-monitor' : 'el-icon-mobile'"></i> {{ items.selected[0].category }}
            </el-tag>
            <el-tag :type="items.selected[0].pinSecurity ? 'warning' : 'info'" size="small">
              <i :class="items.selected[0].pinSecurity ? 'el-icon-lock' : 'el-icon-unlock'"></i> {{ items.selected[0].pinSecurity ? 'Ya' : 'Tidak' }}
            </el-tag>
          </div>
        </div>
        
        <!-- Roles Selection for Parent Menu -->
            <div class="roles-section">
              <div class="roles-header">
                <i class="el-icon-star-on"></i>
                <span>Role untuk Parent Menu</span>
                <span class="roles-count">({{ selectedRoles.length }} dipilih)</span>
              </div>
              
              <!-- Loading State -->
              <div v-if="loadingRoles" class="roles-loading">
                <i class="el-icon-loading"></i>
                <p>Memuat data roles...</p>
              </div>
              
              <!-- Roles Grid -->
              <div v-else class="roles-grid">
                <div 
                  v-for="role in availableRoles" 
                  :key="role.value"
                  @click="toggleRole(role.value, items.selected[0].id)"
                  :class="['role-card', { 
                    selected: selectedRoles.includes(role.value) || isRoleAssignedToMenu(role, items.selected[0].id) 
                  }]">
                  <div class="role-card-icon">
                    <i :class="role.icon"></i>
                  </div>
                  <div class="role-card-content">
                    <h5 class="role-card-title">{{ role.label }}</h5>
                    <p class="role-card-desc">{{ role.description }}</p>
                  </div>
                  <div class="role-card-check">
                    <i class="el-icon-check"></i>
                  </div>
                </div>
              </div>
            </div>

        <!-- Tabs -->
        <el-tabs v-model="kelolaActiveTab" type="card" class="kelola-tabs">
          <!-- Tab Submenu Management -->
          <el-tab-pane label="Kelola Submenu" name="submenu">
            <div class="tab-icon-wrapper">
              <i class="el-icon-menu"></i> Kelola Submenu
            </div>
            
            <!-- Add Submenu Button -->
            <div class="submenu-actions">
              <el-button type="primary" icon="el-icon-plus" @click="showAddSubmenuForm" size="small" round>
                Tambah Submenu
              </el-button>
              <span class="submenu-count">{{ submenus.length }} submenu</span>
            </div>

            <!-- Add/Edit Submenu Form -->
            <transition name="slide-fade">
              <div v-if="submenuForm.show" class="submenu-form-container">
                <div class="submenu-form-header">
                  <i :class="submenuForm.isEdit ? 'el-icon-edit' : 'el-icon-plus'"></i>
                  <span>{{ submenuForm.isEdit ? 'Edit Submenu' : 'Tambah Submenu Baru' }}</span>
                </div>
                <div class="submenu-form-body">
                  <!-- Label -->
                  <div class="submenu-form-group">
                    <label>Label Submenu</label>
                    <el-input v-model="submenuForm.data.label" placeholder="Masukkan label submenu" size="small">
                      <i slot="prefix" class="el-input__icon el-icon-document"></i>
                    </el-input>
                  </div>

                  <!-- Path -->
                  <div class="submenu-form-group">
                    <label>Path Submenu</label>
                    <el-input v-model="submenuForm.data.path" placeholder="/parent/submenu-path" size="small">
                      <i slot="prefix" class="el-input__icon el-icon-link"></i>
                    </el-input>
                  </div>

                  <!-- Category & Pin Security -->
                  <div class="submenu-form-row">
                    <div class="submenu-form-group">
                      <label>Category</label>
                      <el-select v-model="submenuForm.data.category" placeholder="Pilih category" size="small" style="width: 100%">
                        <el-option label="WEB" value="WEB"></el-option>
                        <el-option label="MOBILE" value="MOBILE"></el-option>
                        <el-option label="PELAYANAN" value="PELAYANAN"></el-option>
                      </el-select>
                    </div>
                    <div class="submenu-form-group">
                      <label>Pin Security</label>
                      <div class="switch-container-small">
                        <el-switch 
                          v-model="submenuForm.data.pinSecurity"
                          active-color="#13ce66"
                          inactive-color="#dcdfe6">
                        </el-switch>
                        <span class="switch-label">{{ submenuForm.data.pinSecurity ? 'Ya' : 'Tidak' }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Icon -->
                  <div class="submenu-form-group">
                    <label>Icon</label>
                    
                    <!-- Icon Type Selector -->
                    <div class="icon-type-selector-small">
                      <button 
                        type="button"
                        @click="submenuForm.data.iconType = 'code'"
                        :class="['icon-type-btn-small', { active: submenuForm.data.iconType === 'code' }]">
                        <i class="el-icon-edit-outline"></i>
                        <span>Code String</span>
                      </button>
                      <button 
                        type="button"
                        @click="submenuForm.data.iconType = 'upload'"
                        :class="['icon-type-btn-small', { active: submenuForm.data.iconType === 'upload' }]">
                        <i class="el-icon-upload"></i>
                        <span>Upload Image</span>
                      </button>
                    </div>

                    <!-- Code String Input -->
                    <div v-if="submenuForm.data.iconType === 'code'" class="icon-input-wrapper-small">
                      <div v-if="submenuForm.data.icon && !submenuForm.data.iconFile" class="existing-icon-preview-small">
                        <label class="existing-icon-label-small">Icon yang sudah ada:</label>
                        <div class="existing-icon-box-small">
                          <img :src="apiHost + '/api' + submenuForm.data.icon" alt="Existing Icon" />
                        </div>
                      </div>

                      <el-input 
                        v-model="submenuForm.data.icon" 
                        placeholder="/path/to/icon.svg atau el-icon-menu" 
                        size="small">
                        <i slot="prefix" class="el-input__icon el-icon-picture"></i>
                      </el-input>
                      <p class="input-hint-small">Masukkan path icon atau nama class icon</p>
                    </div>

                    <!-- File Upload Input -->
                    <div v-else class="icon-upload-wrapper-small">
                      <div v-if="submenuForm.data.icon && !submenuForm.data.iconFile && !submenuForm.data.iconPreview" class="existing-icon-preview-small">
                        <label class="existing-icon-label-small">Icon yang sudah ada:</label>
                        <div class="existing-icon-box-small">
                          <img :src="apiHost + '/api' + submenuForm.data.icon" alt="Existing Icon" />
                        </div>
                      </div>

                      <div class="upload-area-small" @click="$refs.kelolaSubmenuIconInput.click()">
                        <input 
                          ref="kelolaSubmenuIconInput" 
                          type="file" 
                          @change="handleSubmenuIconFileChange" 
                          accept="image/png,image/jpeg,image/jpg,image/svg+xml,image/gif"
                          style="display: none">
                        
                        <div v-if="!submenuForm.data.iconPreview" class="upload-placeholder-small">
                          <i class="el-icon-upload"></i>
                          <p class="upload-text-small">Klik untuk upload icon</p>
                          <p class="upload-hint-small">PNG, JPG, SVG, GIF (max 2MB)</p>
                        </div>
                        
                        <div v-else class="upload-preview-small">
                          <img :src="submenuForm.data.iconPreview" alt="Icon Preview">
                          <div class="preview-overlay-small">
                            <i class="el-icon-view"></i>
                          </div>
                        </div>
                      </div>
                      
                      <el-button 
                        v-if="submenuForm.data.iconPreview" 
                        @click.stop="clearSubmenuIconFile" 
                        type="danger" 
                        size="mini" 
                        plain
                        class="clear-file-btn-small">
                        <i class="el-icon-delete"></i> Hapus File
                      </el-button>
                    </div>
                  </div>

                  <!-- Actions -->
                  <div class="submenu-form-actions">
                    <el-button size="small" @click="cancelSubmenuForm">
                      <i class="el-icon-close"></i> Batal
                    </el-button>
                    <el-button type="primary" size="small" @click="saveSubmenu" :loading="get_loading">
                      <i class="el-icon-check"></i> {{ submenuForm.isEdit ? 'Update' : 'Simpan' }}
                    </el-button>
                  </div>
                </div>
              </div>
            </transition>

            <!-- Submenu List -->
            <div class="submenu-list-container">
              <div v-if="submenus.length === 0" class="submenu-empty">
                <i class="el-icon-folder-opened"></i>
                <p>Belum ada submenu</p>
                <span>Klik tombol "Tambah Submenu" untuk menambahkan</span>
              </div>
              
              <div v-else class="submenu-list">
                <div v-for="(submenu, index) in submenus" :key="index" class="submenu-item">
                  <div class="submenu-item-icon">
                    <img v-if="submenu.icon" :src="apiHost + '/api' + submenu.icon" alt="icon" />
                    <i v-else class="el-icon-document"></i>
                  </div>
                  <div class="submenu-item-info">
                    <h5 class="submenu-item-label">{{ submenu.label }}</h5>
                    <p class="submenu-item-path">{{ submenu.path }}</p>
                  </div>
                  <div class="submenu-tags-detail">
                    <el-tag :type="submenu.category === 'WEB' ? 'primary' : 'success'" size="small">
                      <i :class="submenu.category == 'WEB' ? 'el-icon-monitor' : 'el-icon-mobile'"></i> {{ submenu.category }}
                    </el-tag>
                    <el-tag :type="submenu.pinSecurity ? 'warning' : 'info'" size="small">
                      <i :class="submenu.pinSecurity ? 'el-icon-lock' : 'el-icon-unlock'"></i> {{ submenu.pinSecurity ? 'Ya' : 'Tidak' }}
                    </el-tag>
                  </div>
                  <div class="submenu-item-actions">
                    <el-button type="primary" icon="el-icon-edit" size="mini" circle @click="editSubmenu(index)"></el-button>
                    <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deleteSubmenu(index)"></el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <!-- Tab Role Management -->
          <el-tab-pane label="Set Role Akses" name="role">
            <div class="tab-icon-wrapper">
              <i class="el-icon-s-custom"></i> Set Role Akses
            </div>

            <!-- Roles Selection for Parent Menu -->
            <!-- <div class="roles-section"> -->
              <!-- <div class="roles-header">
                <i class="el-icon-star-on"></i>
                <span>Role untuk Parent Menu</span>
                <span class="roles-count">({{ selectedRoles.length }} dipilih)</span>
              </div> -->
              
              <!-- Loading State -->
              <!-- <div v-if="loadingRoles" class="roles-loading">
                <i class="el-icon-loading"></i>
                <p>Memuat data roles...</p>
              </div> -->
              
              <!-- Roles Grid -->
              <!-- <div v-else class="roles-grid">
                <div 
                  v-for="role in availableRoles" 
                  :key="role.value"
                  @click="toggleRole(role.value, items.selected[0].id)"
                  :class="['role-card', { 
                    selected: selectedRoles.includes(role.value) || isRoleAssignedToMenu(role, items.selected[0].id) 
                  }]">
                  <div class="role-card-icon">
                    <i :class="role.icon"></i>
                  </div>
                  <div class="role-card-content">
                    <h5 class="role-card-title">{{ role.label }}</h5>
                    <p class="role-card-desc">{{ role.description }}</p>
                  </div>
                  <div class="role-card-check">
                    <i class="el-icon-check"></i>
                  </div>
                </div>
              </div> -->
            <!-- </div> -->

            <!-- Submenus Role Section -->
            <!-- <div v-if="menuDetail && menuDetail.children && menuDetail.children.length > 0" class="submenus-role-section"> -->
            <div v-if="menuDetail && menuDetail.children && menuDetail.children.length > 0">
              <div class="submenus-role-header">
                <i class="el-icon-menu"></i>
                <span>Set Role untuk Submenu</span>
                <span class="submenu-count-badge">{{ menuDetail.children.length }} submenu</span>
              </div>

              <div class="submenus-role-list">
                <div v-for="submenu in menuDetail.children" :key="submenu.id" class="submenu-role-item">
                  <div class="submenu-role-info">
                    <div class="submenu-role-icon">
                      <img :src="apiHost + '/api' + submenu.icon" alt="icon" />
                    </div>
                    <div class="submenu-role-details">
                      <h5 class="submenu-role-label">{{ submenu.label }}</h5>
                      <p class="submenu-role-path">{{ submenu.path }}</p>
                    </div>
                    <div class="submenu-role-tags">
                      <el-tag :type="submenu.category === 'WEB' ? 'primary' : 'success'" size="mini">
                        <i :class="submenu.category === 'WEB' ? 'el-icon-monitor' : 'el-icon-mobile'"></i> {{ submenu.category }}
                      </el-tag>
                    </div>
                  </div>
                  
                  <div class="submenu-roles-grid">
                    <div 
                      v-for="role in availableRoles" 
                      :key="role.value + '-' + submenu.id"
                      @click="toggleRole(role.value, submenu.id)"
                      :class="['submenu-role-card', { 
                        selected: isRoleAssignedToMenu(role, submenu.id) 
                      }]">
                      <i :class="role.icon"></i>
                      <span>{{ role.label }}</span>
                      <div class="submenu-role-check">
                        <i class="el-icon-check"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      
      <span slot="footer" class="kelola-dialog-footer">
        <el-button @click="dialogs.kelola = false" class="cancel-btn">
          <i class="el-icon-close"></i> Tutup
        </el-button>
        <el-button type="primary" @click="saveKelolaChanges" class="submit-btn kelola-save-btn" :loading="get_loading">
          <i class="el-icon-check"></i> Simpan Perubahan
        </el-button>
      </span>
    </el-dialog>

    <!-- Dialog Detail -->
    <el-dialog :visible.sync="dialogs.detail" width="650px" top="8vh" custom-class="detail-dialog">
      <div slot="title" class="detail-dialog-header">
        <i class="el-icon-info"></i>
        <span>Detail Menu</span>
      </div>
      <div v-if="menuDetail || items.selected.length === 1" class="detail-content">
        <!-- Icon & Title Section -->
        <div class="detail-hero">
          <div class="detail-icon-wrapper">
            <img :src="apiHost + '/api' + (menuDetail ? menuDetail.icon : items.selected[0].icon)" alt="icon" class="detail-icon" />
          </div>
          <div class="detail-title-section">
            <h2 class="detail-menu-label">{{ menuDetail ? menuDetail.label : items.selected[0].label }}</h2>
            <p class="detail-menu-path">
              <!-- <i class="el-icon-link"></i> -->
              {{ menuDetail ? menuDetail.path : items.selected[0].path }}
            </p>
          </div>
        </div>

        <!-- Info Cards -->
        <el-row :gutter="20" class="detail-cards">
          <el-col :span="12">
            <el-card shadow="hover" class="info-card">
              <div class="info-card-content">
                <div class="info-icon">
                  <i :class="(menuDetail ? menuDetail.category : items.selected[0].category) === 'WEB' ? 'el-icon-monitor' : 'el-icon-mobile'"></i>
                </div>
                <div class="info-text">
                  <p class="info-label">Category</p>
                  <el-tag :type="(menuDetail ? menuDetail.category : items.selected[0].category) === 'WEB' ? 'primary' : 'success'" size="medium">
                    {{ menuDetail ? menuDetail.category : items.selected[0].category }}
                  </el-tag>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card shadow="hover" class="info-card">
              <div class="info-card-content">
                <div class="info-icon">
                  <i :class="(menuDetail ? menuDetail.pinSecurity : items.selected[0].pinSecurity) ? 'el-icon-lock' : 'el-icon-unlock'"></i>
                </div>
                <div class="info-text">
                  <p class="info-label">Pin Security</p>
                  <el-tag :type="(menuDetail ? menuDetail.pinSecurity : items.selected[0].pinSecurity) ? 'warning' : 'info'" size="medium">
                    {{ (menuDetail ? menuDetail.pinSecurity : items.selected[0].pinSecurity) ? 'Ya' : 'Tidak' }}
                  </el-tag>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <!-- Additional Info -->
        <el-card shadow="never" class="additional-info">
          <div slot="header" class="clearfix">
            <i class="el-icon-document"></i>
            <span style="margin-left: 8px;">Informasi Tambahan</span>
          </div>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="ID">
              <el-tag size="small" type="info">{{ menuDetail ? menuDetail.id : items.selected[0].id }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="Created At">
              <i class="el-icon-time"></i>
              {{ (menuDetail ? menuDetail.createdAt : items.selected[0].createdAt) || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="Parent ID" v-if="menuDetail && menuDetail.parentId">
              <el-tag size="small" type="success">{{ menuDetail.parentId }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="Jumlah Submenu" v-if="menuDetail && menuDetail.children">
              <el-tag size="small" type="primary">{{ menuDetail.children.length }} submenu</el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- Submenus Section (if exists) -->
        <el-card shadow="never" class="submenus-info" v-if="menuDetail && menuDetail.children && menuDetail.children.length > 0">
          <div slot="header" class="clearfix">
            <i class="el-icon-menu"></i>
            <span style="margin-left: 8px;">Daftar Submenu</span>
          </div>
          <div class="submenu-list-detail">
            <div v-for="(submenu, index) in menuDetail.children" :key="index" class="submenu-item-detail">
              <div class="submenu-icon-detail">
                <img v-if="submenu.icon" :src="apiHost + '/api' + submenu.icon" alt="icon" />
                <i v-else class="el-icon-document"></i>
              </div>
              <div class="submenu-info-detail">
                <h5>{{ submenu.label }}</h5>
                <p>{{ submenu.path }}</p>
              </div>
              <div class="submenu-tags-detail">
                <el-tag :type="submenu.category === 'WEB' ? 'primary' : 'success'" size="small">
                  <i :class="submenu.category == 'WEB' ? 'el-icon-monitor' : 'el-icon-mobile'"></i> {{ submenu.category }}
                </el-tag>
                <el-tag :type="submenu.pinSecurity ? 'warning' : 'info'" size="small">
                  <i :class="submenu.pinSecurity ? 'el-icon-lock' : 'el-icon-unlock'"></i> {{ submenu.pinSecurity ? 'Ya' : 'Tidak' }}
                </el-tag>
              </div>
            </div>
          </div>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogs.detail = false" icon="el-icon-close">Tutup</el-button>
      </span>
    </el-dialog>

    <!-- Dialog Set Role -->
    <el-dialog :visible.sync="dialogs.setRole" width="650px" top="10vh" custom-class="form-dialog">
      <div slot="title" class="form-dialog-header">
        <!-- <div class="form-icon-wrapper role-icon">
          <i class="el-icon-user"></i>
        </div> -->
        <div>
          <h3 class="form-title">Set Role Akses</h3>
          <p class="form-subtitle">Tentukan role yang dapat mengakses menu</p>
        </div>
      </div>
      
      <div v-if="items.selected.length === 1" class="role-content">
        <!-- Menu Info Card -->
        <div class="menu-info-card">
          <div class="menu-info-icon">
            <img :src="apiHost + '/api' + items.selected[0].icon" alt="icon" />
          </div>
          <div class="menu-info-details">
            <h4 class="menu-info-label leading-none">{{ items.selected[0].label }}</h4>
            <p class="menu-info-path leading-none">
              <!-- <i class="el-icon-link"></i> -->
              {{ items.selected[0].path }}
            </p>
          </div>
          <div>
            <el-tag :type="items.selected[0].category === 'WEB' ? 'primary' : 'success'" size="small">
              <i :class="items.selected[0].category == 'WEB' ? 'el-icon-monitor' : 'el-icon-mobile'"></i> {{ items.selected[0].category }}
            </el-tag>
          </div>
          <div>
            <el-tag :type="items.selected[0].pinSecurity ? 'warning' : 'info'" size="small">
              <i :class="items.selected[0].pinSecurity ? 'el-icon-lock' : 'el-icon-unlock'"></i> {{ items.selected[0].pinSecurity ? 'Ya' : 'Tidak' }}
            </el-tag>
          </div>
        </div>

        <!-- Roles Selection -->
        <div class="roles-section">
          <div class="roles-header">
            <i class="el-icon-s-custom"></i>
            <span>Pilih Role Akses</span>
            <span class="roles-count">({{ selectedRoles.length }} dipilih)</span>
          </div>
          
          <!-- Loading State -->
          <div v-if="loadingRoles" class="roles-loading">
            <i class="el-icon-loading"></i>
            <p>Memuat data roles...</p>
          </div>
          
          <!-- Roles Grid -->
          <div v-else class="roles-grid">
            <!-- {{ selectedRoles }} -->
            <!-- {{ valueSelectedRoles }} -->
            <!-- {{ availableRoles }} -->
            <div 
              v-for="role in availableRoles" 
              :key="role.value"
              @click="toggleRole(role.value, items.selected[0].id)"
              :class="['role-card', { 
                selected: selectedRoles.includes(role.value) || isRoleAssignedToMenu(role, items.selected[0].id) 
              }]">
              <div class="role-card-icon">
                <i :class="role.icon"></i>
              </div>
              <div class="role-card-content">
                <h5 class="role-card-title">{{ role.label }}</h5>
                <p class="role-card-desc">{{ role.description }}</p>
              </div>
              <div class="role-card-check">
                <i class="el-icon-check"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Submenus Section -->
        <!-- <div v-if="menuDetail && menuDetail.children && menuDetail.children.length > 0" class="submenus-role-section"> -->
        <div v-if="menuDetail && menuDetail.children && menuDetail.children.length > 0">
          <div class="submenus-role-header">
            <i class="el-icon-menu"></i>
            <span>Set Role untuk Submenu</span>
            <span class="submenu-count-badge">{{ menuDetail.children.length }} submenu</span>
          </div>

          <div class="submenus-role-list">
            <div v-for="submenu in menuDetail.children" :key="submenu.id" class="submenu-role-item">
              <div class="submenu-role-info">
                <div class="submenu-role-icon">
                  <img :src="apiHost + '/api' + submenu.icon" alt="icon" />
                </div>
                <div class="submenu-role-details">
                  <h5 class="submenu-role-label">{{ submenu.label }}</h5>
                  <p class="submenu-role-path">{{ submenu.path }}</p>
                </div>
                <div class="submenu-role-tags">
                  <el-tag :type="submenu.category === 'WEB' ? 'primary' : 'success'" size="mini">
                    <i :class="submenu.category === 'WEB' ? 'el-icon-monitor' : 'el-icon-mobile'"></i> {{ submenu.category }}
                  </el-tag>
                  <el-tag :type="submenu.pinSecurity ? 'warning' : 'info'" size="mini">
                    <i :class="submenu.pinSecurity ? 'el-icon-lock' : 'el-icon-unlock'"></i> {{ submenu.pinSecurity ? 'Ya' : 'Tidak' }} 
                  </el-tag> 
                </div>
              </div>
              
              <div class="submenu-roles-grid">
                <div 
                  v-for="role in availableRoles" 
                  :key="role.value + '-' + submenu.id"
                  @click="toggleRole(role.value, submenu.id)"
                  :class="['submenu-role-card', { 
                    selected: isRoleAssignedToMenu(role, submenu.id) 
                  }]">
                  <i :class="role.icon"></i>
                  <span>{{ role.label }}</span>
                  <div class="submenu-role-check">
                    <i class="el-icon-check"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <span slot="footer" class="form-dialog-footer">
        <el-button @click="dialogs.setRole = false" class="cancel-btn">
          <i class="el-icon-close"></i> Batal
        </el-button>
        <el-button type="primary" @click="saveRoles" class="submit-btn role-btn" :loading="get_loading">
          <i class="el-icon-check"></i> Simpan Role
        </el-button>
      </span>
    </el-dialog>

    <!-- Dialog Set Submenu -->
    <el-dialog :visible.sync="dialogs.setSubmenu" width="750px" top="8vh" custom-class="submenu-dialog">
      <div slot="title" class="submenu-dialog-header">
        <!-- <div class="submenu-icon-wrapper">
          <i class="el-icon-menu"></i>
        </div> -->
        <div>
          <h3 class="submenu-title">Kelola Submenu</h3>
          <p class="submenu-subtitle">Tambah, edit, atau hapus submenu</p>
        </div>
      </div>
      
      <div v-if="items.selected.length === 1" class="submenu-content">
        <!-- Parent Menu Info -->
        <div class="parent-menu-card">
          <!-- <div class="parent-menu-badge">Parent Menu</div> -->
          <div class="parent-menu-info">
            <div class="parent-menu-icon">
              <img :src="apiHost + '/api' + items.selected[0].icon" alt="icon" />
            </div>
            <div class="parent-menu-details">
              <h4 class="parent-menu-label leading-none">{{ items.selected[0].label }}</h4>
              <p class="parent-menu-path leading-none">{{ items.selected[0].path }}</p>
            </div>
            <div>
              <el-tag :type="items.selected[0].category === 'WEB' ? 'primary' : 'success'" size="small">
                <i :class="items.selected[0].category == 'WEB' ? 'el-icon-monitor' : 'el-icon-mobile'"></i> {{ items.selected[0].category }}
              </el-tag>
            </div>
            <div>
              <el-tag :type="items.selected[0].pinSecurity ? 'warning' : 'info'" size="small">
                <i :class="items.selected[0].pinSecurity ? 'el-icon-lock' : 'el-icon-unlock'"></i> {{ items.selected[0].pinSecurity ? 'Ya' : 'Tidak' }}
              </el-tag>
            </div>
          </div>
        </div>

        <!-- Add Submenu Button -->
        <div class="submenu-actions">
          <el-button type="primary" icon="el-icon-plus" @click="showAddSubmenuForm" size="small" round>
            Tambah Submenu
          </el-button>
          <span class="submenu-count">{{ submenus.length }} submenu</span>
        </div>
        <!-- {{ submenus }} -->
        <!-- Add/Edit Submenu Form -->
        <transition name="slide-fade">
          <div v-if="submenuForm.show" class="submenu-form-container">
            <div class="submenu-form-header">
              <i :class="submenuForm.isEdit ? 'el-icon-edit' : 'el-icon-plus'"></i>
              <span>{{ submenuForm.isEdit ? 'Edit Submenu' : 'Tambah Submenu Baru' }}</span>
            </div>
            <div class="submenu-form-body">
              <!-- Label -->
              <div class="submenu-form-group">
                <label>Label Submenu</label>
                <el-input v-model="submenuForm.data.label" placeholder="Masukkan label submenu" size="small">
                  <i slot="prefix" class="el-input__icon el-icon-document"></i>
                </el-input>
              </div>

              <!-- Path -->
              <div class="submenu-form-group">
                <label>Path Submenu</label>
                <el-input v-model="submenuForm.data.path" placeholder="/parent/submenu-path" size="small">
                  <i slot="prefix" class="el-input__icon el-icon-link"></i>
                </el-input>
              </div>

              <!-- Category & Pin Security -->
              <div class="submenu-form-row">
                <div class="submenu-form-group">
                  <label>Category</label>
                  <el-select v-model="submenuForm.data.category" placeholder="Pilih category" size="small" style="width: 100%">
                    <el-option label="WEB" value="WEB"></el-option>
                    <el-option label="MOBILE" value="MOBILE"></el-option>
                    <el-option label="PELAYANAN" value="PELAYANAN"></el-option>
                  </el-select>
                </div>
                <div class="submenu-form-group">
                  <label>Pin Security</label>
                  <div class="switch-container-small">
                    <el-switch 
                      v-model="submenuForm.data.pinSecurity"
                      active-color="#13ce66"
                      inactive-color="#dcdfe6">
                    </el-switch>
                    <span class="switch-label">{{ submenuForm.data.pinSecurity ? 'Ya' : 'Tidak' }}</span>
                  </div>
                </div>
              </div>

              <!-- Icon -->
              <div class="submenu-form-group">
                <label>Icon</label>
                
                <!-- Icon Type Selector -->
                <div class="icon-type-selector-small">
                  <button 
                    type="button"
                    @click="submenuForm.data.iconType = 'code'"
                    :class="['icon-type-btn-small', { active: submenuForm.data.iconType === 'code' }]">
                    <i class="el-icon-edit-outline"></i>
                    <span>Code String</span>
                  </button>
                  <button 
                    type="button"
                    @click="submenuForm.data.iconType = 'upload'"
                    :class="['icon-type-btn-small', { active: submenuForm.data.iconType === 'upload' }]">
                    <i class="el-icon-upload"></i>
                    <span>Upload Image</span>
                  </button>
                </div>

                <!-- Code String Input -->
                <div v-if="submenuForm.data.iconType === 'code'" class="icon-input-wrapper-small">
                  <!-- Existing Icon Preview -->
                  <div v-if="submenuForm.data.icon && !submenuForm.data.iconFile" class="existing-icon-preview-small">
                    <label class="existing-icon-label-small">Icon yang sudah ada:</label>
                    <div class="existing-icon-box-small">
                      <img :src="apiHost + '/api' + submenuForm.data.icon" alt="Existing Icon" />
                    </div>
                  </div>

                  <el-input 
                    v-model="submenuForm.data.icon" 
                    placeholder="/path/to/icon.svg atau el-icon-menu" 
                    size="small">
                    <i slot="prefix" class="el-input__icon el-icon-picture"></i>
                  </el-input>
                  <p class="input-hint-small">Masukkan path icon atau nama class icon</p>
                </div>

                <!-- File Upload Input -->
                <div v-else class="icon-upload-wrapper-small">
                  <!-- Existing Icon Preview -->
                  <div v-if="submenuForm.data.icon && !submenuForm.data.iconFile && !submenuForm.data.iconPreview" class="existing-icon-preview-small">
                    <label class="existing-icon-label-small">Icon yang sudah ada:</label>
                    <div class="existing-icon-box-small">
                      <img :src="apiHost + '/api' + submenuForm.data.icon" alt="Existing Icon" />
                    </div>
                  </div>

                  <div class="upload-area-small" @click="$refs.submenuIconFileInput.click()">
                    <input 
                      ref="submenuIconFileInput" 
                      type="file" 
                      @change="handleSubmenuIconFileChange" 
                      accept="image/png,image/jpeg,image/jpg,image/svg+xml,image/gif"
                      style="display: none">
                    
                    <div v-if="!submenuForm.data.iconPreview" class="upload-placeholder-small">
                      <i class="el-icon-upload"></i>
                      <p class="upload-text-small">Klik untuk upload icon</p>
                      <p class="upload-hint-small">PNG, JPG, SVG, GIF (max 2MB)</p>
                    </div>
                    
                    <div v-else class="upload-preview-small">
                      <img :src="submenuForm.data.iconPreview" alt="Icon Preview">
                      <div class="preview-overlay-small">
                        <i class="el-icon-view"></i>
                      </div>
                    </div>
                  </div>
                  
                  <!-- File Info Display -->
                  <!-- <div v-if="submenuForm.data.iconFile" class="file-info-box-small">
                    <div class="file-info-content-small">
                      <div class="file-info-row-small">
                        <span class="file-info-label-small">File:</span>
                        <span class="file-info-value-small">{{ submenuForm.data.iconFile.name }}</span>
                      </div>
                      <div class="file-info-row-small">
                        <span class="file-info-label-small">Size:</span>
                        <span class="file-info-value-small">{{ formatFileSize(submenuForm.data.iconFile.size) }}</span>
                      </div>
                    </div>
                  </div> -->
                  
                  <el-button 
                    v-if="submenuForm.data.iconPreview" 
                    @click.stop="clearSubmenuIconFile" 
                    type="danger" 
                    size="mini" 
                    plain
                    class="clear-file-btn-small">
                    <i class="el-icon-delete"></i> Hapus File
                  </el-button>
                </div>
              </div>

              <!-- Actions -->
              <div class="submenu-form-actions">
                <el-button size="small" @click="cancelSubmenuForm">
                  <i class="el-icon-close"></i> Batal
                </el-button>
                <el-button type="primary" size="small" @click="saveSubmenu" :loading="get_loading">
                  <i class="el-icon-check"></i> {{ submenuForm.isEdit ? 'Update' : 'Simpan' }}
                </el-button>
              </div>
            </div>
          </div>
        </transition>

        <!-- Submenu List -->
        <div class="submenu-list-container">
          <div v-if="submenus.length === 0" class="submenu-empty">
            <i class="el-icon-folder-opened"></i>
            <p>Belum ada submenu</p>
            <span>Klik tombol "Tambah Submenu" untuk menambahkan</span>
          </div>
          
          <div v-else class="submenu-list">
            <div v-for="(submenu, index) in submenus" :key="index" class="submenu-item">
              <!-- <div class="submenu-item-order">{{ submenu.order }}</div> -->
              <div class="submenu-item-icon">
                <img v-if="submenu.icon" :src="apiHost + '/api' + submenu.icon" alt="icon" />
                <i v-else class="el-icon-document"></i>
              </div>
              <div class="submenu-item-info">
                <h5 class="submenu-item-label">{{ submenu.label }}</h5>
                <p class="submenu-item-path">{{ submenu.path }}</p>
              </div>
              <div class="submenu-tags-detail">
                <el-tag :type="submenu.category === 'WEB' ? 'primary' : 'success'" size="small">
                  <i :class="submenu.category == 'WEB' ? 'el-icon-monitor' : 'el-icon-mobile'"></i> {{ submenu.category }}
                </el-tag>
                <el-tag :type="submenu.pinSecurity ? 'warning' : 'info'" size="small">
                  <i :class="submenu.pinSecurity ? 'el-icon-lock' : 'el-icon-unlock'"></i> {{ submenu.pinSecurity ? 'Ya' : 'Tidak' }}
                </el-tag>
              </div>
              <div class="submenu-item-actions">
                <el-button type="primary" icon="el-icon-edit" size="mini" circle @click="editSubmenu(index)"></el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deleteSubmenu(index)"></el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <span slot="footer" class="submenu-dialog-footer">
        <el-button @click="dialogs.setSubmenu = false" class="cancel-btn">
          <i class="el-icon-close"></i> Tutup
        </el-button>
        <el-button type="success" @click="saveAllSubmenus" class="submit-btn submenu-save-btn">
          <i class="el-icon-check"></i> Simpan Semua
        </el-button>
      </span>
    </el-dialog>

    <!-- Dialog Tambah -->
    <el-dialog :visible.sync="dialogs.tambah" width="650px" top="10vh" custom-class="form-dialog">
      <div slot="title" class="form-dialog-header">
        <!-- <div class="form-icon-wrapper add-icon">
          <i class="el-icon-plus"></i>
        </div> -->
        <div>
          <h3 class="form-title">Tambah Menu Baru</h3>
          <p class="form-subtitle">Lengkapi form untuk menambahkan menu</p>
        </div>
      </div>
      <div class="form-content">
        <div class="form-group">
          <label class="form-label">
            <i class="el-icon-document"></i>
            <span>Label Menu</span>
          </label>
          <el-input 
            v-model="formData.label" 
            placeholder="Masukkan label menu" 
            class="modern-input"
            prefix-icon="el-icon-edit">
          </el-input>
        </div>

        <div class="form-group">
          <label class="form-label">
            <i class="el-icon-link"></i>
            <span>Path</span>
          </label>
          <el-input 
            v-model="formData.path" 
            placeholder="/example/path" 
            class="modern-input"
            prefix-icon="el-icon-connection">
          </el-input>
        </div>

        <div class="form-row">
          <div class="form-group form-group-half">
            <label class="form-label">
              <i class="el-icon-menu"></i>
              <span>Category</span>
            </label>
            <el-select 
              v-model="formData.category" 
              placeholder="Pilih category" 
              class="modern-select"
              style="width: 100%">
              <el-option label="WEB" value="WEB">
                <span>WEB</span>
              </el-option>
              <el-option label="MOBILE" value="MOBILE">
                <span>MOBILE</span>
              </el-option>
              <el-option label="PELAYANAN" value="PELAYANAN">
                <span>PELAYANAN</span>
              </el-option>
            </el-select>
          </div>

          <div class="form-group form-group-half">
            <label class="form-label">
              <i class="el-icon-lock"></i>
              <span>Pin Security</span>
            </label>
            <div class="switch-container">
              <el-switch 
                v-model="formData.pinSecurity"
                active-color="#13ce66"
                inactive-color="#dcdfe6">
              </el-switch>
              <span class="switch-label">{{ formData.pinSecurity ? 'Ya' : 'Tidak' }}</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">
            <i class="el-icon-picture"></i>
            <span>Icon</span>
          </label>
          
          <!-- Icon Type Selector -->
          <div class="icon-type-selector">
            <button 
              type="button"
              @click="formData.iconType = 'code'"
              :class="['icon-type-btn', { active: formData.iconType === 'code' }]">
              <i class="el-icon-edit-outline"></i>
              <span>Code String</span>
            </button>
            <button 
              type="button"
              @click="formData.iconType = 'upload'"
              :class="['icon-type-btn', { active: formData.iconType === 'upload' }]">
              <i class="el-icon-upload"></i>
              <span>Upload Image</span>
            </button>
          </div>

          <!-- Code String Input -->
          <div v-if="formData.iconType === 'code'" class="icon-input-wrapper">
            <el-input 
              v-model="formData.icon" 
              placeholder="/path/to/icon.svg atau el-icon-menu" 
              class="modern-input"
              prefix-icon="el-icon-picture-outline">
            </el-input>
            <p class="input-hint">Masukkan path icon atau nama class icon</p>
          </div>

          <!-- File Upload Input -->
          <div v-else class="icon-upload-wrapper">
            <div class="upload-area" @click="$refs.iconFileInput.click()">
              <input 
                ref="iconFileInput" 
                type="file" 
                @change="handleIconFileChange" 
                accept="image/png,image/jpeg,image/jpg,image/svg+xml,image/gif"
                style="display: none">
              
              <div v-if="!formData.iconPreview" class="upload-placeholder">
                <i class="el-icon-upload"></i>
                <p class="upload-text">Klik untuk upload icon</p>
                <p class="upload-hint">PNG, JPG, SVG, GIF (max 2MB)</p>
              </div>
              
              <div v-else class="upload-preview">
                <img :src="formData.iconPreview" alt="Icon Preview">
                <div class="preview-overlay">
                  <i class="el-icon-view"></i>
                </div>
              </div>
            </div>
            
            <!-- File Info Display -->
            <div v-if="formData.iconFile" class="file-info-box">
              <div class="file-info-header">
                <i class="el-icon-document"></i>
                <span class="file-info-title">File yang akan diupload:</span>
              </div>
              <div class="file-info-content">
                <div class="file-info-row">
                  <span class="file-info-label">Nama File:</span>
                  <span class="file-info-value">{{ formData.iconFile.name }}</span>
                </div>
                <div class="file-info-row">
                  <span class="file-info-label">Ukuran:</span>
                  <span class="file-info-value">{{ formatFileSize(formData.iconFile.size) }}</span>
                </div>
                <div class="file-info-row">
                  <span class="file-info-label">Tipe:</span>
                  <span class="file-info-value file-type-badge">{{ formData.iconFile.type }}</span>
                </div>
              </div>
            </div>
            
            <el-button 
              v-if="formData.iconPreview" 
              @click.stop="clearIconFile" 
              type="danger" 
              size="small" 
              plain
              class="clear-file-btn">
              <i class="el-icon-delete"></i> Hapus File
            </el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="form-dialog-footer">
        <el-button @click="dialogs.tambah = false" class="cancel-btn">
          <i class="el-icon-close"></i> Batal
        </el-button>
        <el-button type="primary" @click="tambahMenu" class="submit-btn add-btn" :loading="get_loading">
          <i class="el-icon-check"></i> Tambah Menu
        </el-button>
      </span>
    </el-dialog>

    <!-- Dialog Edit -->
    <el-dialog :visible.sync="dialogs.edit" width="650px" top="10vh" custom-class="form-dialog">
      <div slot="title" class="form-dialog-header">
        <!-- <div class="form-icon-wrapper edit-icon">
          <i class="el-icon-edit"></i>
        </div> -->
        <div>
          <h3 class="form-title">Edit Menu</h3>
          <p class="form-subtitle">Perbarui informasi menu yang dipilih</p>
        </div>
      </div>
      <div class="form-content" v-if="items.selected.length === 1">
        <!-- {{ items.selected[0].id }} -->
        <div class="form-group">
          <label class="form-label">
            <i class="el-icon-document"></i>
            <span>Label Menu</span>
          </label>
          <el-input 
            v-model="formData.label" 
            placeholder="Masukkan label menu" 
            class="modern-input"
            prefix-icon="el-icon-edit">
          </el-input>
        </div>

        <div class="form-group">
          <label class="form-label">
            <i class="el-icon-link"></i>
            <span>Path</span>
          </label>
          <el-input 
            v-model="formData.path" 
            placeholder="/example/path" 
            class="modern-input"
            prefix-icon="el-icon-connection">
          </el-input>
        </div>

        <div class="form-row">
          <div class="form-group form-group-half">
            <label class="form-label">
              <i class="el-icon-menu"></i>
              <span>Category</span>
            </label>
            <el-select 
              v-model="formData.category" 
              placeholder="Pilih category" 
              class="modern-select"
              style="width: 100%">
              <el-option label="WEB" value="WEB">
                <span style="float: left">🌐 WEB</span>
              </el-option>
              <el-option label="MOBILE" value="MOBILE">
                <span style="float: left">📱 MOBILE</span>
              </el-option>
            </el-select>
          </div>

          <div class="form-group form-group-half">
            <label class="form-label">
              <i class="el-icon-lock"></i>
              <span>Pin Security</span>
            </label>
            <div class="switch-container">
              <el-switch 
                v-model="formData.pinSecurity"
                active-color="#13ce66"
                inactive-color="#dcdfe6">
              </el-switch>
              <span class="switch-label">{{ formData.pinSecurity ? 'Aktif' : 'Nonaktif' }}</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">
            <i class="el-icon-picture"></i>
            <span>Icon</span>
          </label>
          
          <!-- Icon Type Selector - Hanya untuk WEB -->
          <div v-if="formData.category === 'WEB'" class="icon-type-selector">
            <button 
              type="button"
              @click="formData.iconType = 'code'"
              :class="['icon-type-btn', { active: formData.iconType === 'code' }]">
              <i class="el-icon-edit-outline"></i>
              <span>Code String</span>
            </button>
            <button 
              type="button"
              @click="formData.iconType = 'upload'"
              :class="['icon-type-btn', { active: formData.iconType === 'upload' }]">
              <i class="el-icon-upload"></i>
              <span>Upload Image</span>
            </button>
          </div>

          <!-- Info Badge untuk MOBILE -->
          <!-- <div v-if="formData.category === 'MOBILE'" class="mobile-icon-info">
            <i class="el-icon-info"></i>
            <span>Category MOBILE hanya mendukung upload image</span>
          </div> -->

          <!-- Code String Input - Hanya untuk WEB -->
          <div v-if="formData.category === 'WEB' && formData.iconType === 'code'" class="icon-input-wrapper">
            <!-- Preview Existing Icon -->
            <div v-if="formData.icon && !formData.iconFile" class="existing-icon-preview">
              <div class="existing-icon-label">
                <i class="el-icon-picture-outline"></i>
                <span>Icon Saat Ini:</span>
              </div>
              <div class="existing-icon-box">
                <img :src="apiHost + '/api' + formData.icon" alt="current icon" />
              </div>
            </div>
            
            <el-input 
              v-model="formData.icon" 
              placeholder="/path/to/icon.svg atau el-icon-menu" 
              class="modern-input"
              prefix-icon="el-icon-picture-outline">
            </el-input>
            <p class="input-hint">Masukkan path icon atau nama class icon</p>
          </div>

          <!-- File Upload Input - Untuk MOBILE atau WEB dengan iconType upload -->
          <div v-if="formData.category === 'MOBILE' || (formData.category === 'WEB' && formData.iconType === 'upload')" class="icon-upload-wrapper">
            <!-- Preview Existing Icon sebelum upload baru -->
            <div v-if="formData.icon && !formData.iconFile && !formData.iconPreview" class="existing-icon-preview">
              <div class="existing-icon-label">
                <i class="el-icon-picture-outline"></i>
                <span>Icon Saat Ini:</span>
              </div>
              <div class="existing-icon-box">
                <img :src="apiHost + '/api' + formData.icon" alt="current icon" />
              </div>
            </div>
            
            <div class="upload-area" @click="$refs.iconFileInputEdit.click()">
              <input 
                ref="iconFileInputEdit" 
                type="file" 
                @change="handleIconFileChange" 
                accept="image/png,image/jpeg,image/jpg,image/svg+xml,image/gif"
                style="display: none">
              
              <div v-if="!formData.iconPreview" class="upload-placeholder">
                <i class="el-icon-upload"></i>
                <p class="upload-text">Klik untuk upload icon</p>
                <p class="upload-hint">PNG, JPG, SVG, GIF (max 2MB)</p>
              </div>
              
              <div v-else class="upload-preview">
                <img :src="formData.iconPreview" alt="Icon Preview">
                <div class="preview-overlay">
                  <i class="el-icon-view"></i>
                </div>
              </div>
            </div>
            
            <!-- File Info Display -->
            <!-- <div v-if="formData.iconFile" class="file-info-box">
              <div class="file-info-header">
                <i class="el-icon-document"></i>
                <span class="file-info-title">File yang akan diupload:</span>
              </div>
              <div class="file-info-content">
                <div class="file-info-row">
                  <span class="file-info-label">Nama File:</span>
                  <span class="file-info-value">{{ formData.iconFile.name }}</span>
                </div>
                <div class="file-info-row">
                  <span class="file-info-label">Ukuran:</span>
                  <span class="file-info-value">{{ formatFileSize(formData.iconFile.size) }}</span>
                </div>
                <div class="file-info-row">
                  <span class="file-info-label">Tipe:</span>
                  <span class="file-info-value file-type-badge">{{ formData.iconFile.type }}</span>
                </div>
              </div>
            </div> -->
            
            <el-button 
              v-if="formData.iconPreview" 
              @click.stop="clearIconFile" 
              type="danger" 
              size="small" 
              plain
              class="clear-file-btn">
              <i class="el-icon-delete"></i> Hapus File
            </el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="form-dialog-footer">
        <el-button @click="dialogs.edit = false" class="cancel-btn">
          <i class="el-icon-close"></i> Batal
        </el-button>
        <el-button type="primary" @click="updateMenu(items.selected[0].id)" class="submit-btn edit-btn">
          <i class="el-icon-check"></i> Update Menu
        </el-button>
      </span>
    </el-dialog>

    <!-- Dialog Hapus -->
    <el-dialog :visible.sync="dialogs.hapus" width="550px" top="15vh" custom-class="delete-dialog">
      <div slot="title" class="delete-dialog-header">
        <!-- <div class="delete-icon-wrapper">
          <i class="el-icon-warning"></i>
        </div> -->
        <div>
          <h3 class="delete-title">Konfirmasi Hapus</h3>
          <p class="delete-subtitle">Tindakan ini tidak dapat dibatalkan</p>
        </div>
      </div>
      <div class="delete-content">
        <div class="delete-warning-box">
          <i class="el-icon-info"></i>
          <p>Anda akan menghapus <strong class="delete-count">{{ items.selected.length }}</strong> menu yang dipilih</p>
        </div>
        
        <div class="delete-list-container">
          <p class="delete-list-title">Daftar menu yang akan dihapus:</p>
          <div class="delete-items-list">
            <div v-for="(item, index) in items.selected" :key="index" class="delete-item">
              <div class="delete-item-icon">
                <img :src="apiHost + '/api' + item.icon" alt="icon" />
              </div>
              <div class="delete-item-info">
                <p class="delete-item-label leading-none">{{ item.label }}</p>
                <p class="delete-item-path leading-none">{{ item.path }}</p>
              </div>
              <el-tag :type="item.category === 'WEB' ? 'primary' : 'success'" size="mini">
                <i :class="item.category == 'WEB' ? 'el-icon-monitor' : 'el-icon-mobile'"></i> {{ item.category }}
              </el-tag>
              <el-tag :type="item.pinSecurity ? 'warning' : 'info'" size="mini">
                <i :class="item.pinSecurity ? 'el-icon-lock' : 'el-icon-unlock'"></i> {{ item.pinSecurity ? 'Ya' : 'Tidak' }}
              </el-tag>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogs.hapus = false" size="medium">
          <i class="el-icon-close"></i>
          Batal
        </el-button>
        <el-button type="danger" @click="hapusMenu" size="medium" :loading="get_loading">
          <i class="el-icon-delete"></i>
          Ya, Hapus Sekarang
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "MenuManagement",
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      items: { selected: [] },
      menuDetail: null,
      filters: {
        name: '',
        category: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dialogs: {
        detail: false,
        kelola: false,
        setRole: false,
        setSubmenu: false,
        tambah: false,
        edit: false,
        hapus: false
      },
      kelolaActiveTab: 'submenu',
      selectedRoles: [],
      valueSelectedRoles: [],
      loadingRoles: false,
      submenus: [],
      submenuForm: {
        show: false,
        isEdit: false,
        editIndex: null,
        data: {
          label: '',
          path: '',
          category: 'WEB',
          pinSecurity: false,
          icon: '',
          iconType: 'code',
          iconFile: null,
          iconPreview: ''
        }
      },
      availableRoles: [
        {
          value: 'ROLE_ADMIN',
          label: 'ROLE_ADMIN',
          icon: 'el-icon-s-tools',
          description: 'Akses penuh ke semua fitur',
          roleName: 'ROLE_ADMIN',
          menuIds: []
        },
        {
          value: 'ROLE_OPERATOR',
          label: 'ROLE_OPERATOR',
          icon: 'el-icon-user',
          description: 'Akses standar pengguna',
          roleName: 'ROLE_OPERATOR',
          menuIds: []
        },
        {
          value: 'ROLE_ADMIN_INFORMATION',
          label: 'ROLE_ADMIN_INFORMATION',
          icon: 'el-icon-s-custom',
          description: 'Akses manajemen tim',
          roleName: 'ROLE_ADMIN_INFORMATION',
          menuIds: []
        },
        {
          value: 'ROLE_EMPLOYEE',
          label: 'ROLE_EMPLOYEE',
          icon: 'el-icon-view',
          description: 'Akses terbatas view only',
          roleName: 'ROLE_EMPLOYEE',
          menuIds: []
        }
      ],
      formData: {
        id: null,
        label: '',
        path: '',
        category: 'WEB',
        pinSecurity: false,
        icon: '',
        iconType: 'code',
        iconFile: null,
        iconPreview: ''
      }
    };
  },
  computed: {
    // API Host dari environment variable
    apiHost() {
      return process.env.VUE_APP_API_HOST || 'http://localhost:8020'
    },
    get_menus() {
      const menus = this.$store.state.menus.menus;
      return Array.isArray(menus) ? menus : [];
    },
    get_code() {
      return this.$store.state.menus.code;
    },
    get_message() {
      return this.$store.state.menus.message;
    },
    get_loading() {
      return this.$store.state.menus.loading;
    },
    filteredMenus() {
      if (!Array.isArray(this.get_menus) || this.get_menus.length === 0) {
        return [];
      }
      
      let filtered = this.get_menus;
      
      // Filter by name
      if (this.filters.name) {
        const searchTerm = this.filters.name.toLowerCase();
        filtered = filtered.filter(menu => 
          menu.label.toLowerCase().includes(searchTerm) || 
          menu.path.toLowerCase().includes(searchTerm)
        );
      }
      
      // Filter by category
      if (this.filters.category) {
        filtered = filtered.filter(menu => menu.category === this.filters.category);
      }
      
      return filtered;
    },
    paginatedMenus() {
      if (this.filteredMenus.length === 0) {
        this.pagination.total = 0;
        return [];
      }
      const start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
      const end = start + this.pagination.pageSize;
      this.pagination.total = this.filteredMenus.length;
      return this.filteredMenus.slice(start, end);
    }
  },
  watch: {
    'formData.category'(newVal) {
      // Otomatis set ke upload mode ketika category MOBILE dipilih
      if (newVal === 'MOBILE') {
        this.formData.iconType = 'upload';
      }
    },
    'filters.name'() {
      this.pagination.currentPage = 1;
      this.items.selected = [];
      this.checkAll = false;
    },
    'filters.category'() {
      this.pagination.currentPage = 1;
      this.items.selected = [];
      this.checkAll = false;
    }
  },
  created() {
    this.$store.dispatch('menus/fetchMenus', { token: this.getAuthToken() });
    this.getFetchRoleMore();
  },
  methods: {
    getAuthToken() {
      return localStorage.getItem('token') || sessionStorage.getItem('token') || ''
    },
    // Check apakah role sudah ter-assign ke menu tertentu
    isRoleAssignedToMenu(role, menuId) {
      if (!role.menuIds || !Array.isArray(role.menuIds)) {
        return false;
      }
      return role.menuIds.includes(menuId);
    },
    refreshMenus() {
      this.$store.dispatch('menus/fetchMenus', { token: this.getAuthToken() });
    },
    handleCheckAllChange(event) {
      // Ketika check all diklik, pilih atau hapus semua item (simpan seluruh data item)
      this.items.selected = event.target.checked ? [...this.get_menus] : [];
      this.isIndeterminate = false;
    },
    handleCheckChange() {
      // Ketika individual checkbox berubah, update status check all
      const checkedCount = this.items.selected.length;
      this.checkAll = checkedCount === this.get_menus.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.get_menus.length;
    },
    handleIconFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        // Validasi tipe file
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'image/gif'];
        if (!validTypes.includes(file.type)) {
          this.$message.error('Format file tidak valid. Gunakan PNG, JPG, SVG, atau GIF');
          return;
        }
        
        // Validasi ukuran file (max 2MB)
        if (file.size > 2 * 1024 * 1024) {
          this.$message.error('Ukuran file maksimal 2MB');
          return;
        }
        
        this.formData.iconFile = file;
        
        // Buat preview
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.iconPreview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    handleSubmenuIconFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        // Validasi tipe file
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'image/gif'];
        if (!validTypes.includes(file.type)) {
          this.$message.error('Format file tidak valid. Gunakan PNG, JPG, SVG, atau GIF');
          return;
        }
        
        // Validasi ukuran file (max 2MB)
        if (file.size > 2 * 1024 * 1024) {
          this.$message.error('Ukuran file maksimal 2MB');
          return;
        }
        
        this.submenuForm.data.iconFile = file;
        
        // Buat preview
        const reader = new FileReader();
        reader.onload = (e) => {
          this.submenuForm.data.iconPreview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    clearIconFile() {
      this.formData.iconFile = null;
      this.formData.iconPreview = '';
      // Reset input file untuk dialog tambah
      const fileInput = this.$refs.iconFileInput;
      if (fileInput) {
        fileInput.value = '';
      }
      // Reset input file untuk dialog edit
      const fileInputEdit = this.$refs.iconFileInputEdit;
      if (fileInputEdit) {
        fileInputEdit.value = '';
      }
    },
    clearSubmenuIconFile() {
      this.submenuForm.data.iconFile = null;
      this.submenuForm.data.iconPreview = '';
      // Reset input file untuk submenu
      const fileInput = this.$refs.submenuIconFileInput;
      if (fileInput) {
        fileInput.value = '';
      }
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    },
    toggleRole(roleValue, menuId) {
      const index = this.selectedRoles.indexOf(roleValue);
      if (index > -1) {
        // Jika sudah ada, hapus dari array
        this.selectedRoles.splice(index, 1);
        this.valueSelectedRoles.splice(index, 1);
        this.availableRoles.forEach(role => {
          if (role.value === roleValue) {
            const menuIndex = role.menuIds.indexOf(menuId);
            if (menuIndex > -1) {
              role.menuIds.splice(menuIndex, 1);
            }
          }
        });
      } else {
        // Jika belum ada, tambahkan ke array
        this.selectedRoles.push(roleValue);
        this.valueSelectedRoles.push({"roleName":roleValue,"menuIds": [menuId]});
        this.availableRoles.forEach(role => {
          if (role.value === roleValue) {
            role.menuIds.push(menuId);
          }
        });
      }
    },
    async showDetailDialog() {
      try {
        const menuId = this.items.selected[0].id;
        
        // Fetch detail menu dari API
        const menuData = await this.$store.dispatch('menus/fetchMenuById', { 
          token: this.getAuthToken(), 
          id: menuId 
        });
        
        // Simpan ke state lokal untuk ditampilkan
        this.menuDetail = menuData || this.items.selected[0];
        
        this.dialogs.detail = true;
      } catch (error) {
        console.error('Error loading menu detail:', error);
        this.$message.error('Gagal memuat detail menu');
        // Fallback ke data yang sudah ada
        this.menuDetail = this.items.selected[0];
        this.dialogs.detail = true;
      }
    },
    async showSetRoleDialog() {
      // Reset arrays
      this.selectedRoles = [];
      this.valueSelectedRoles = [];
      
      try {
        const menuId = this.items.selected[0].id;
        
        // Pre-populate dari availableRoles yang sudah ter-assign
        this.availableRoles.forEach(role => {
          if (this.isRoleAssignedToMenu(role, menuId)) {
            if (!this.selectedRoles.includes(role.value)) {
              this.selectedRoles.push(role.value);
              this.valueSelectedRoles.push({
                roleName: role.value,
                menuIds: [menuId]
              });
            }
          }
        });
        
        // Fetch detail menu dari API untuk mendapatkan roles yang sudah di-assign dan submenus
        const menuData = await this.$store.dispatch('menus/fetchMenuById', { 
          token: this.getAuthToken(), 
          id: menuId 
        });
        
        // Simpan menuDetail untuk menampilkan submenus
        this.menuDetail = menuData || this.items.selected[0];
        
        // Jika menu memiliki roles yang sudah di-assign dari API, tambahkan juga
        if (menuData && menuData.roles && Array.isArray(menuData.roles)) {
          menuData.roles.forEach(role => {
            const roleName = role.roleName || role.name || role;
            if (roleName && !this.selectedRoles.includes(roleName)) {
              this.selectedRoles.push(roleName);
              this.valueSelectedRoles.push({
                roleName: roleName,
                menuIds: [menuId]
              });
            }
          });
        }
        
        // Pre-populate roles untuk submenus jika ada
        if (menuData && menuData.children && Array.isArray(menuData.children)) {
          menuData.children.forEach(submenu => {
            // Check role assignments untuk setiap submenu dari availableRoles.menuIds
            this.availableRoles.forEach(role => {
              if (role.menuIds && role.menuIds.includes(submenu.id)) {
                // Role sudah ter-assign ke submenu ini
                // Data sudah ada di availableRoles.menuIds, tidak perlu push lagi
              }
            });
          });
        }
        
        this.dialogs.setRole = true;
      } catch (error) {
        console.error('Error loading menu roles:', error);
        // Tetap buka dialog meskipun error
        this.dialogs.setRole = true;
      }
    },
    async showKelolaDialog() {
      // Reset state
      this.kelolaActiveTab = 'submenu';
      this.selectedRoles = [];
      this.valueSelectedRoles = [];
      this.submenuForm = {
        show: false,
        isEdit: false,
        editIndex: null,
        data: {
          label: '',
          path: '',
          category: 'WEB',
          pinSecurity: false,
          icon: '',
          iconType: 'code',
          iconFile: null,
          iconPreview: ''
        }
      };
      
      try {
        const menuId = this.items.selected[0].id;
        
        // Fetch detail menu dengan submenus
        const menuData = await this.$store.dispatch('menus/fetchMenuById', { 
          token: this.getAuthToken(), 
          id: menuId 
        });
        
        // Simpan menuDetail
        this.menuDetail = menuData || this.items.selected[0];
        
        // Load submenus
        if (menuData && menuData.children && Array.isArray(menuData.children)) {
          this.submenus = menuData.children;
        } else {
          this.submenus = [];
        }
        
        // Pre-populate roles untuk parent menu
        this.availableRoles.forEach(role => {
          if (this.isRoleAssignedToMenu(role, menuId)) {
            if (!this.selectedRoles.includes(role.value)) {
              this.selectedRoles.push(role.value);
              this.valueSelectedRoles.push({
                roleName: role.value,
                menuIds: [menuId]
              });
            }
          }
        });
        
        // Pre-populate roles dari API
        if (menuData && menuData.roles && Array.isArray(menuData.roles)) {
          menuData.roles.forEach(role => {
            const roleName = role.roleName || role.name || role;
            if (roleName && !this.selectedRoles.includes(roleName)) {
              this.selectedRoles.push(roleName);
              this.valueSelectedRoles.push({
                roleName: roleName,
                menuIds: [menuId]
              });
            }
          });
        }
        
        this.dialogs.kelola = true;
      } catch (error) {
        console.error('Error loading menu data:', error);
        this.$message.error('Gagal memuat data menu');
        this.dialogs.kelola = true;
      }
    },
    async saveKelolaChanges() {
      try {
        // Save roles
        if (this.availableRoles && this.availableRoles.length > 0) {
          for (let i = 0; i < this.availableRoles.length; i++) {
            const roleData = {
              roleName: this.availableRoles[i].value,
              menuIds: this.availableRoles[i].menuIds
            };
            await this.$store.dispatch('roles/createRole', {
              token: this.getAuthToken(),
              role: roleData
            });
          }
        }
        
        this.$message.success('Perubahan berhasil disimpan');
        this.dialogs.kelola = false;
        
        // Refresh data
        await this.$store.dispatch('menus/fetchMenus', { token: this.getAuthToken() });
      } catch (error) {
        this.$message.error('Gagal menyimpan perubahan');
        console.error('Error saving changes:', error);
      }
    },
    async showSetSubmenuDialog() {
      // Reset submenu form
      this.submenuForm = {
        show: false,
        isEdit: false,
        editIndex: null,
        data: {
          label: '',
          path: '',
          category: 'WEB',
          pinSecurity: false,
          icon: '',
          iconType: 'code',
          iconFile: null,
          iconPreview: ''
        }
      };
      
      // Load existing submenus from API
      try {
        const menuId = this.items.selected[0].id;
        const menuData = await this.$store.dispatch('menus/fetchMenuById', { 
          token: this.getAuthToken(), 
          id: menuId 
        });
        
        // Extract submenus from menuData (children)
        // Assuming API returns menu with children array
        if (menuData && menuData.children && Array.isArray(menuData.children)) {
          this.submenus = menuData.children;
        } else if (menuData && Array.isArray(menuData)) {
          // If API returns array directly
          this.submenus = menuData;
        } else {
          this.submenus = [];
        }
        
        this.dialogs.setSubmenu = true;
      } catch (error) {
        console.error('Error loading submenus:', error);
        this.$message.error('Gagal memuat submenu');
        this.submenus = [];
      }
    },
    showAddSubmenuForm() {
      this.submenuForm = {
        show: true,
        isEdit: false,
        editIndex: null,
        data: {
          label: '',
          path: '',
          category: 'WEB',
          pinSecurity: false,
          icon: '',
          iconType: 'code',
          iconFile: null,
          iconPreview: ''
        }
      };
    },
    cancelSubmenuForm() {
      this.submenuForm.show = false;
      this.submenuForm.data = {
        label: '',
        path: '',
        category: 'WEB',
        pinSecurity: false,
        icon: '',
        iconType: 'code',
        iconFile: null,
        iconPreview: ''
      };
    },
    async saveSubmenu() {
      // Validation
      if (!this.submenuForm.data.label || !this.submenuForm.data.path) {
        this.$message.error('Label dan Path harus diisi');
        return;
      }

      const formData = new FormData();
      formData.append('label', this.submenuForm.data.label);
      formData.append('path', this.submenuForm.data.path);
      formData.append('pinSecurity', this.submenuForm.data.pinSecurity ? '1' : '0');
      formData.append('category', this.submenuForm.data.category);
      formData.append('parentId', this.items.selected[0].id || '');

      // Handle icon berdasarkan iconType
      if (this.submenuForm.data.iconType === 'upload' && this.submenuForm.data.iconFile) {
        formData.append('iconFile', this.submenuForm.data.iconFile);
      } else if (this.submenuForm.data.iconType === 'code' && this.submenuForm.data.icon) {
        formData.append('icon', this.submenuForm.data.icon);
      }

      console.log(formData);
      
      try {
        if (this.submenuForm.isEdit) {
          // Update existing submenu via API
          const submenuId = this.submenus[this.submenuForm.editIndex].id;
          await this.$store.dispatch('menus/updateMenu', { 
            token: this.getAuthToken(), 
            form_data: formData, 
            id: submenuId 
          });
          this.$message.success('Submenu berhasil diupdate');
        } else {
          // Add new submenu via API
          await this.$store.dispatch('menus/createMenu', { 
            token: this.getAuthToken(), 
            form_data: formData 
          });
          this.$message.success('Submenu berhasil ditambahkan');
        }
        
        // Refresh data menus
        await this.$store.dispatch('menus/fetchMenus', { token: this.getAuthToken() });
        
        // Reload submenus for current parent
        await this.loadSubmenus(this.items.selected[0].id);
        
        this.cancelSubmenuForm();
      } catch (error) {
        this.$message.error('Gagal menyimpan submenu');
        console.error('Error saving submenu:', error);
      }
    },
    async loadSubmenus(menuId) {
      try {
        const menuData = await this.$store.dispatch('menus/fetchMenuById', { 
          token: this.getAuthToken(), 
          id: menuId 
        });
        
        // Extract submenus from menuData (children)
        if (menuData && menuData.children && Array.isArray(menuData.children)) {
          this.submenus = menuData.children;
        } else if (menuData && Array.isArray(menuData)) {
          this.submenus = menuData;
        } else {
          this.submenus = [];
        }
      } catch (error) {
        console.error('Error loading submenus:', error);
        this.submenus = [];
      }
    },
    editSubmenu(index) {
      const submenu = this.submenus[index];
      this.submenuForm = {
        show: true,
        isEdit: true,
        editIndex: index,
        data: { 
          ...submenu,
          iconType: submenu.icon && submenu.icon.startsWith('/') ? 'code' : 'code',
          iconFile: null,
          iconPreview: ''
        }
      };
      
      // Scroll to form
      this.$nextTick(() => {
        const formElement = document.querySelector('.submenu-form-container');
        if (formElement) {
          formElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    },
    async deleteSubmenu(index) {
      this.$confirm('Hapus submenu ini?', 'Konfirmasi', {
        confirmButtonText: 'Hapus',
        cancelButtonText: 'Batal',
        type: 'warning'
      }).then(async () => {
        try {
          const submenuId = this.submenus[index].id;
          
          // Delete via API
          await this.$store.dispatch('menus/deleteMenu', {
            token: this.getAuthToken(),
            id: submenuId
          });
          
          this.$message.success('Submenu berhasil dihapus');
          
          // Refresh data menus
          await this.$store.dispatch('menus/fetchMenus', { token: this.getAuthToken() });
          
          // Reload submenus for current parent
          await this.loadSubmenus(this.items.selected[0].id);
        } catch (error) {
          this.$message.error('Gagal menghapus submenu');
          console.error('Error deleting submenu:', error);
        }
      }).catch(() => {
        // Cancelled
      });
    },
    saveAllSubmenus() {
      // TODO: Save to API
      console.log('Saving submenus:', this.submenus);
      this.$message.success(`${this.submenus.length} submenu berhasil disimpan untuk ${this.items.selected[0].label}`);
      this.dialogs.setSubmenu = false;
    },
    showTambahDialog() {
      this.formData = {
        label: '',
        path: '',
        category: 'WEB',
        pinSecurity: false,
        icon: '',
        iconType: 'code',
        iconFile: null,
        iconPreview: ''
      };
      this.dialogs.tambah = true;
    },
    showEditDialog() {
      const selected = this.items.selected[0];
      this.formData = {
        label: selected.label,
        path: selected.path,
        category: selected.category,
        pinSecurity: selected.pinSecurity,
        icon: selected.icon,
        iconType: 'code',
        iconFile: null,
        iconPreview: ''
      };
      this.dialogs.edit = true;
    },
    showHapusDialog() {
      this.dialogs.hapus = true;
    },
    async saveRoles() {
      // Validasi apakah ada role yang dipilih
      if (this.valueSelectedRoles.length === 0) {
        this.$message.warning('Pilih minimal satu role');
        return;
      }

      try {
        // Loop untuk setiap role yang dipilih dan kirim ke API
        // for (const roleData of this.valueSelectedRoles) {
        for (let i = 0; i < this.availableRoles.length; i++) {
          const roleData = {
            roleName: this.availableRoles[i].value,
            menuIds: this.availableRoles[i].menuIds
          };
          await this.$store.dispatch('roles/createRole', {
            token: this.getAuthToken(),
            role: roleData
          });
        }

        this.$message.success(`Roles berhasil disimpan untuk ${this.items.selected[0].label}`);
        console.log('Saved Roles:', this.valueSelectedRoles);
        
        // Reset dan tutup dialog
        this.selectedRoles = [];
        this.valueSelectedRoles = [];
        this.dialogs.setRole = false;
      } catch (error) {
        this.$message.error('Gagal menyimpan roles');
        console.error('Error saving roles:', error);
      }
    },
    async tambahMenu() {
      // Validasi form
      if (!this.formData.label || !this.formData.path) {
        this.$message.error('Label dan Path harus diisi');
        return;
      }

      const formData = new FormData();
      formData.append('label', this.formData.label);
      formData.append('path', this.formData.path);
      formData.append('pinSecurity', this.formData.pinSecurity ? '1' : '0');
      formData.append('category', this.formData.category);
      formData.append('parentId', this.formData.parentId || '');

      // Handle icon berdasarkan iconType
      if (this.formData.iconType === 'upload' && this.formData.iconFile) {
        formData.append('iconFile', this.formData.iconFile);
      } else if (this.formData.iconType === 'code' && this.formData.icon) {
        formData.append('icon', this.formData.icon);
      }

      try {
        await this.$store.dispatch('menus/createMenu', { token: this.getAuthToken(), form_data: formData });
        
        this.$message.success('Menu berhasil ditambahkan!');
        this.dialogs.tambah = false;
        
        // Refresh data menus
        await this.$store.dispatch('menus/fetchMenus', { token: this.getAuthToken() });
      } catch (error) {
        this.$message.error('Gagal menambahkan menu');
        console.error('Error creating menu:', error);
      }
    },
    async updateMenu(id) {
      // console.log('Form Data:', this.formData);

      // TODO: Implementasi API call untuk update menu
      // Validasi form
      if (!this.formData.label || !this.formData.path) {
        this.$message.error('Label dan Path harus diisi');
        return;
      }

      const formData = new FormData();
      formData.append('label', this.formData.label);
      formData.append('path', this.formData.path);
      formData.append('pinSecurity', this.formData.pinSecurity ? '1' : '0');
      formData.append('category', this.formData.category);
      formData.append('parentId', this.formData.parentId || '');

      // Handle icon berdasarkan iconType
      if (this.formData.iconType === 'upload' && this.formData.iconFile) {
        formData.append('iconFile', this.formData.iconFile);
      } else if (this.formData.iconType === 'code' && this.formData.icon) {
        formData.append('icon', this.formData.icon);
      }

      try {
        await this.$store.dispatch('menus/updateMenu', { token: this.getAuthToken(), form_data: formData, id: id });
        
        this.$message.success('Menu berhasil diupdate!');
        this.dialogs.edit = false;
        this.items.selected = [];
        // Refresh data menus
        await this.$store.dispatch('menus/fetchMenus', { token: this.getAuthToken() });
      } catch (error) {
        this.$message.error('Gagal mengupdate menu');
        console.error('Error updating menu:', error);
      }
    },
    async hapusMenu() {
      try {
        const selectedCount = this.items.selected.length;
        
        if (selectedCount === 0) {
          this.$message.warning('Tidak ada menu yang dipilih');
          return;
        }

        // Jika hanya 1 data, langsung delete tanpa loop
        if (selectedCount === 1) {
          await this.$store.dispatch('menus/deleteMenu', { 
            token: this.getAuthToken(), 
            id: this.items.selected[0].id 
          });
        } else {
          // Jika lebih dari 1, loop untuk menghapus satu per satu
          for (const menu of this.items.selected) {
            await this.$store.dispatch('menus/deleteMenu', { 
              token: this.getAuthToken(), 
              id: menu.id 
            });
          }
        }
        
        this.$message.success(`${selectedCount} menu berhasil dihapus!`);
        
        // Reset selection
        this.items.selected = [];
        this.checkAll = false;
        this.dialogs.hapus = false;
        
        // Refresh data menus
        await this.$store.dispatch('menus/fetchMenus', { token: this.getAuthToken() });
      } catch (error) {
        this.$message.error('Gagal menghapus menu');
        console.error('Error deleting menu:', error);
      }
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
    },
    async getFetchRoleMore() {
      this.loadingRoles = true;
      try {
        // Buat array promises untuk semua dispatch dengan tracking roleName
        const promises = [];
        const roleMapping = []; // Simpan mapping index -> roleName
        
        for (let index = 0; index < this.availableRoles.length; index++) {
          const element = this.availableRoles[index];
          const roleName = element.value;
          
          // Push semua dispatch ke array promises dan simpan roleName
          promises.push(
            this.$store.dispatch('roles/getRoleByNameMobile', { 
              token: this.getAuthToken(), 
              roleName: roleName 
            })
          );
          roleMapping.push(roleName); // Index mapping untuk mobile
          
          promises.push(
            this.$store.dispatch('roles/getRoleByNameWeb', { 
              token: this.getAuthToken(), 
              roleName: roleName 
            })
          );
          roleMapping.push(roleName); // Index mapping untuk web
          
          promises.push(
            this.$store.dispatch('roles/getRoleByNamePelayanan', { 
              token: this.getAuthToken(), 
              roleName: roleName 
            })
          );
          roleMapping.push(roleName); // Index mapping untuk pelayanan
        }
        
        // Jalankan semua promises secara parallel dan tunggu semua selesai
        const results = await Promise.all(promises);
        
        // Process results: ambil data saja, skip jika data kosong atau data = []
        const processedData = results
          .map((result, index) => {
            // Ambil roleName dari mapping berdasarkan index
            const roleName = roleMapping[index];
            
            // Ambil data dari result (bisa result.data atau result langsung)
            const data = result?.data || result;
            
            // Skip jika data tidak ada, kosong array, atau bukan object/array
            if (!data || (Array.isArray(data) && data.length === 0)) {
              return null;
            }
            
            // Jika data adalah array, extract semua menuIds
            if (Array.isArray(data)) {
              // Ambil semua id dari array data
              const menuIds = data
                .map(item => item.id || item.menuId)
                .filter(id => id !== undefined && id !== null);
              
              // Skip jika tidak ada menuIds
              if (menuIds.length === 0) {
                return null;
              }
              
              return {
                roleName: roleName,
                menuIds: menuIds
              };
            }
            
            // Jika data adalah object tunggal
            if (typeof data === 'object' && (data.id || data.menuId)) {
              return {
                roleName: roleName,
                menuIds: [data.id || data.menuId]
              };
            }
            
            return null;
          })
          .filter(item => item !== null); // Hapus semua item yang null (di-skip)
        
        // Update availableRoles dengan menuIds yang didapat dari API
        // Group menuIds berdasarkan roleName
        const roleMenuMap = {};
        processedData.forEach(item => {
          if (!roleMenuMap[item.roleName]) {
            roleMenuMap[item.roleName] = [];
          }
          // Gabungkan semua menuIds untuk role yang sama
          roleMenuMap[item.roleName].push(...item.menuIds);
        });
        
        // Remove duplicates dari menuIds dan update availableRoles
        Object.keys(roleMenuMap).forEach(roleName => {
          roleMenuMap[roleName] = [...new Set(roleMenuMap[roleName])];
          
          // Update availableRoles
          const roleIndex = this.availableRoles.findIndex(r => r.value === roleName);
          if (roleIndex !== -1) {
            this.availableRoles[roleIndex].menuIds = roleMenuMap[roleName];
          }
        });
        
        console.log('Processed role data:', processedData);
        console.log('Updated availableRoles:', this.availableRoles);
        
        return processedData;
      } catch (error) {
        console.error('Error fetching role data:', error);
        throw error;
      } finally {
        this.loadingRoles = false;
      }
    } 
  }
};
</script>
<style scoped>
.menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 0.5px solid #ccc;
  gap: 15px;
}

.menu-header-filters {
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.menu-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
  border-bottom: 0.5px solid #ccc;
}

.menu-zero {
  margin-right: 15px;
}

.menu-first {
  margin-right: 15px;
}

.menu-second {
  flex-grow: 1;
}

.menu-third, .menu-fourth {
  width: 100px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-footer {
  margin: 20px 0 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-label {
  font-weight: bold;
  font-size: 18px;
  margin: 0;
}

.menu-path {
  color: #666;
  margin: 5px 0 0 0;
}

/* Detail Dialog Styles */
.detail-dialog-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 600;
  color: #409EFF;
}

.detail-dialog-header i {
  font-size: 24px;
}

.detail-content {
  padding: 10px 0;
}

.detail-hero {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  margin-bottom: 20px;
  color: white;
}

.detail-icon-wrapper {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  backdrop-filter: blur(10px);
}

.detail-icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.detail-title-section {
  flex: 1;
}

.detail-menu-label {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: white;
}

.detail-menu-path {
  margin: 8px 0 0 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  gap: 5px;
}

.detail-cards {
  margin-bottom: 20px;
}

.info-card {
  border-radius: 10px;
  transition: all 0.3s ease;
}

.info-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.info-card-content {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 10px;
}

.info-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
}

.info-text {
  flex: 1;
}

.info-label {
  margin: 0 0 5px 0;
  font-size: 12px;
  color: #909399;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.additional-info {
  margin-top: 20px;
  border-radius: 10px;
}

.additional-info .el-card__header {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #303133;
}

/* Submenus Info in Detail Dialog */
.submenus-info {
  margin-top: 20px;
  border-radius: 10px;
}

.submenus-info .el-card__header {
  background-color: #f0f9ff;
  font-weight: 600;
  color: #1890ff;
}

.submenu-list-detail {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.submenu-item-detail {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #fafbfc;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.submenu-item-detail:hover {
  background: #ecf5ff;
  border-color: #409EFF;
  transform: translateX(3px);
}

.submenu-icon-detail {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: white;
  border: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.submenu-icon-detail img {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}

.submenu-icon-detail i {
  font-size: 20px;
  color: #909399;
}

.submenu-info-detail {
  flex: 1;
  min-width: 0;
}

.submenu-info-detail h5 {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.submenu-info-detail p {
  margin: 0;
  font-size: 12px;
  color: #909399;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.submenu-tags-detail {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

/* Delete Dialog Styles */
.delete-dialog-header {
  display: flex;
  align-items: center;
  gap: 15px;
}

.delete-icon-wrapper {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 28px;
  animation: pulse-warning 2s infinite;
}

@keyframes pulse-warning {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.7);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(255, 107, 107, 0);
  }
}

.delete-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.delete-subtitle {
  margin: 5px 0 0 0;
  font-size: 13px;
  color: #909399;
}

.delete-content {
  padding: 10px 0;
}

.delete-warning-box {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px;
  background: linear-gradient(135deg, #fff3cd 0%, #ffe5a1 100%);
  border-left: 4px solid #ff9800;
  border-radius: 8px;
  margin-bottom: 20px;
}

.delete-warning-box i {
  font-size: 24px;
  color: #ff9800;
}

.delete-warning-box p {
  margin: 0;
  color: #856404;
  font-size: 14px;
}

.delete-count {
  color: #d32f2f;
  font-size: 16px;
}

.delete-list-container {
  margin-top: 20px;
}

.delete-list-title {
  font-size: 14px;
  font-weight: 600;
  color: #606266;
  margin-bottom: 12px;
}

.delete-items-list {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 8px;
}

.delete-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: white;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  margin-bottom: 8px;
  transition: all 0.3s ease;
}

.delete-item:last-child {
  margin-bottom: 0;
}

.delete-item:hover {
  background: #fff5f5;
  border-color: #ffcdd2;
  transform: translateX(5px);
}

.delete-item-icon {
  width: 40px;
  height: 40px;
  background: #f5f7fa;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.delete-item-icon img {
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.delete-item-info {
  flex: 1;
  min-width: 0;
}

.delete-item-label {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.delete-item-path {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.delete-items-list::-webkit-scrollbar {
  width: 6px;
}

.delete-items-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.delete-items-list::-webkit-scrollbar-thumb {
  background: #ff6b6b;
  border-radius: 10px;
}

.delete-items-list::-webkit-scrollbar-thumb:hover {
  background: #ee5a52;
}

/* Form Dialog Styles (Tambah & Edit) */
.form-dialog-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}

.form-icon-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 26px;
  position: relative;
  overflow: hidden;
}

.form-icon-wrapper::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.form-dialog-header:hover .form-icon-wrapper::before {
  transform: translateX(100%);
}

.add-icon {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  box-shadow: 0 4px 15px rgba(79, 172, 254, 0.4);
}

.edit-icon {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  box-shadow: 0 4px 15px rgba(250, 112, 154, 0.4);
}

.form-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.form-subtitle {
  margin: 5px 0 0 0;
  font-size: 13px;
  color: #909399;
}

.form-content {
  padding: 20px 0;
  max-height: 65vh;
  overflow-y: auto;
}

.form-group {
  margin-bottom: 24px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #606266;
  margin-bottom: 10px;
}

.form-label i {
  color: #409EFF;
  font-size: 16px;
}

.modern-input {
  transition: all 0.3s ease;
}

.modern-input input {
  border-radius: 8px;
  border: 2px solid #DCDFE6;
  padding: 12px 15px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.modern-input input:focus {
  border-color: #409EFF;
  box-shadow: 0 0 0 4px rgba(64, 158, 255, 0.1);
}

.modern-input input::placeholder {
  color: #C0C4CC;
  font-style: italic;
}

.modern-select {
  transition: all 0.3s ease;
}

/* Icon Type Selector */
.icon-type-selector {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  background: #f5f7fa;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
}

.icon-type-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 15px;
  background: transparent;
  border: 2px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #606266;
  transition: all 0.3s ease;
  outline: none;
  font-family: inherit;
}

.icon-type-btn i {
  font-size: 16px;
  transition: all 0.3s ease;
}

.icon-type-btn:hover {
  background: #ecf5ff;
  color: #409EFF;
}

.icon-type-btn:hover i {
  transform: scale(1.1);
}

.icon-type-btn.active {
  background: white;
  border-color: #409EFF;
  color: #409EFF;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  font-weight: 600;
}

/* Mobile Icon Info Badge */
.mobile-icon-info {
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 15px;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(79, 172, 254, 0.3);
}

.mobile-icon-info i {
  font-size: 18px;
  animation: pulse-info 2s infinite;
}

@keyframes pulse-info {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* Icon Input Wrapper */
.icon-input-wrapper {
  position: relative;
}

.existing-icon-preview {
  margin-bottom: 15px;
  padding: 15px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);
  border-radius: 10px;
  border: 2px solid #e4e7ed;
}

.existing-icon-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #606266;
}

.existing-icon-label i {
  font-size: 16px;
  color: #409EFF;
}

.existing-icon-box {
  width: 80px;
  height: 80px;
  background: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 2px solid #e4e7ed;
  transition: all 0.3s ease;
}

.existing-icon-box:hover {
  border-color: #409EFF;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
  transform: scale(1.05);
}

.existing-icon-box img {
  max-width: 60px;
  max-height: 60px;
  object-fit: contain;
}

.input-hint {
  margin: 8px 0 0 0;
  font-size: 12px;
  color: #909399;
  font-style: italic;
}

/* Icon Upload Wrapper */
.icon-upload-wrapper {
  position: relative;
}

.upload-area {
  border: 2px dashed #DCDFE6;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fafafa;
  position: relative;
  overflow: hidden;
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-area:hover {
  border-color: #409EFF;
  background: #ecf5ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
}

.upload-placeholder {
  padding: 20px 0;
  width: 100%;
}

.upload-placeholder i {
  font-size: 48px;
  color: #C0C4CC;
  margin-bottom: 10px;
  display: block;
  transition: all 0.3s ease;
}

.upload-area:hover .upload-placeholder i {
  color: #409EFF;
  transform: scale(1.1);
}

.upload-text {
  margin: 0 0 5px 0;
  font-size: 14px;
  font-weight: 500;
  color: #606266;
}

.upload-hint {
  margin: 0;
  font-size: 12px;
  color: #909399;
}

.upload-preview {
  position: relative;
  width: 150px;
  height: 150px;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
}

.upload-preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: white;
}

.preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.upload-preview:hover .preview-overlay {
  opacity: 1;
}

.preview-overlay i {
  font-size: 32px;
  color: white;
}

.clear-file-btn {
  margin-top: 10px;
  width: 100%;
  border-radius: 6px;
}

.clear-file-btn:hover {
  transform: translateY(-2px);
}

/* File Info Box */
.file-info-box {
  margin-top: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  padding: 15px;
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.file-info-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.file-info-header i {
  font-size: 18px;
}

.file-info-title {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.file-info-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.file-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.file-info-label {
  font-size: 13px;
  opacity: 0.9;
  font-weight: 500;
}

.file-info-value {
  font-size: 13px;
  font-weight: 600;
  text-align: right;
  word-break: break-all;
  max-width: 60%;
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 10px;
  border-radius: 5px;
}

.file-type-badge {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
}

.form-group-half {
  flex: 1;
  margin-bottom: 0;
}

.switch-container {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 15px;
  /* background: #f5f7fa; */
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  transition: all 0.3s ease;
}

.switch-container:hover {
  background: #ecf5ff;
  border-color: #409EFF;
}

.switch-label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
}

.form-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #EBEEF5;
}

.cancel-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background: #f5f7fa;
  border-color: #c0c4cc;
  transform: translateY(-2px);
}

.submit-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

.add-btn {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  border: none;
}

.add-btn:hover {
  background: linear-gradient(135deg, #3a9bef 0%, #00d9ef 100%);
}

.edit-btn {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  border: none;
}

.edit-btn:hover {
  background: linear-gradient(135deg, #e9608b 0%, #edd031 100%);
}

/* Role Dialog Specific Styles */
.role-icon {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
  box-shadow: 0 4px 15px rgba(168, 237, 234, 0.4);
}

.role-content {
  padding: 10px 0;
}

.menu-info-card {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
  margin-bottom: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.menu-info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.menu-info-icon {
  width: 60px;
  height: 60px;
  background: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.menu-info-icon img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.menu-info-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.menu-info-label {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.menu-info-path {
  margin: 0;
  font-size: 13px;
  color: #606266;
  display: flex;
  align-items: center;
  gap: 6px;
}

.menu-info-path i {
  font-size: 14px;
}

.roles-section {
  margin-top: 20px;
}

.roles-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e4e7ed;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.roles-header i {
  font-size: 18px;
  color: #409EFF;
}

.roles-count {
  margin-left: auto;
  font-size: 13px;
  color: #909399;
  font-weight: 500;
  background: #f5f7fa;
  padding: 4px 12px;
  border-radius: 12px;
}

/* Roles Loading State */
.roles-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #909399;
}

.roles-loading i {
  font-size: 48px;
  color: #409EFF;
  margin-bottom: 15px;
  animation: rotate 1.5s linear infinite;
}

.roles-loading p {
  margin: 0;
  font-size: 14px;
  color: #606266;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.roles-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.role-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: white;
  border: 2px solid #e4e7ed;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.role-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: #409EFF;
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.role-card:hover {
  border-color: #409EFF;
  background: #ecf5ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
}

.role-card:hover::before {
  transform: scaleY(1);
}

.role-card.selected {
  border-color: #409EFF;
  background: linear-gradient(135deg, #ecf5ff 0%, #e1f3ff 100%);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.role-card.selected::before {
  transform: scaleY(1);
}

.role-card-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.role-card:hover .role-card-icon {
  transform: scale(1.1) rotate(5deg);
}

.role-card.selected .role-card-icon {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.role-card-content {
  flex: 1;
  min-width: 0;
}

.role-card-title {
  margin: 0 0 4px 0;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.role-card-desc {
  margin: 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

.role-card-check {
  width: 24px;
  height: 24px;
  border: 2px solid #dcdfe6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: bold;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.role-card.selected .role-card-check {
  background: #67C23A;
  border-color: #67C23A;
  animation: checkBounce 0.3s ease;
}

@keyframes checkBounce {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}

.role-btn {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
  border: none;
  color: #303133;
}

.role-btn:hover {
  background: linear-gradient(135deg, #96e0dc 0%, #fcc5d5 100%);
  color: #303133;
}

/* Submenu Dialog Styles */
.submenu-dialog-header {
  display: flex;
  align-items: center;
  gap: 15px;
}

.submenu-icon-wrapper {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 28px;
  box-shadow: 0 4px 15px rgba(67, 233, 123, 0.4);
}

.submenu-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.submenu-subtitle {
  margin: 5px 0 0 0;
  font-size: 13px;
  color: #909399;
}

.submenu-content {
  padding: 10px 0;
  max-height: 70vh;
  overflow-y: auto;
}

.parent-menu-card {
  position: relative;
  margin-bottom: 20px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.parent-menu-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.parent-menu-info {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px;
  background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
}

.parent-menu-icon {
  width: 50px;
  height: 50px;
  background: white;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.parent-menu-icon img {
  width: 35px;
  height: 35px;
  object-fit: contain;
}

.parent-menu-details {
  flex: 1;
}

.parent-menu-label {
  margin: 0 0 5px 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.parent-menu-path {
  margin: 0;
  font-size: 13px;
  color: #606266;
}

.submenu-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 8px;
}

.submenu-count {
  font-size: 13px;
  color: #909399;
  font-weight: 500;
}

/* Submenu Form */
.submenu-form-container {
  margin-bottom: 20px;
  border: 2px solid #409EFF;
  border-radius: 10px;
  overflow: hidden;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.submenu-form-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
  color: white;
  font-weight: 600;
  font-size: 14px;
}

.submenu-form-header i {
  font-size: 18px;
}

.submenu-form-body {
  padding: 20px;
  background: white;
}

.submenu-form-group {
  margin-bottom: 15px;
}

.submenu-form-group:last-child {
  margin-bottom: 0;
}

.submenu-form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #606266;
}

.submenu-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 15px;
}

.switch-container-small {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
}

/* Icon Type Selector Small */
.icon-type-selector-small {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.icon-type-btn-small {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  background: white;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;
  font-weight: 500;
  color: #606266;
}

.icon-type-btn-small i {
  font-size: 14px;
}

.icon-type-btn-small:hover {
  border-color: #409EFF;
  color: #409EFF;
  background: #ecf5ff;
}

.icon-type-btn-small.active {
  border-color: #409EFF;
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

/* Icon Input/Upload Small */
.icon-input-wrapper-small {
  position: relative;
}

.input-hint-small {
  margin-top: 6px;
  font-size: 11px;
  color: #909399;
}

.icon-upload-wrapper-small {
  position: relative;
}

.upload-area-small {
  width: 100%;
  height: 120px;
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fafbfc;
}

.upload-area-small:hover {
  border-color: #409EFF;
  background: #ecf5ff;
}

.upload-placeholder-small {
  text-align: center;
}

.upload-placeholder-small i {
  font-size: 32px;
  color: #c0c4cc;
  margin-bottom: 8px;
}

.upload-text-small {
  margin: 0 0 4px 0;
  font-size: 13px;
  font-weight: 500;
  color: #606266;
}

.upload-hint-small {
  margin: 0;
  font-size: 11px;
  color: #909399;
}

.upload-preview-small {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-preview-small img {
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
}

.preview-overlay-small {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.upload-preview-small:hover .preview-overlay-small {
  opacity: 1;
}

.preview-overlay-small i {
  font-size: 32px;
  color: white;
}

.file-info-box-small {
  margin-top: 10px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 6px;
  border: 1px solid #e4e7ed;
}

.file-info-content-small {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.file-info-row-small {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
}

.file-info-label-small {
  color: #909399;
  font-weight: 500;
}

.file-info-value-small {
  color: #606266;
  font-weight: 600;
}

.clear-file-btn-small {
  width: 100%;
  margin-top: 8px;
}

/* Existing Icon Preview Small */
.existing-icon-preview-small {
  margin-bottom: 12px;
  padding: 10px;
  background: #f0f9ff;
  border: 1px solid #bae7ff;
  border-radius: 8px;
}

.existing-icon-label-small {
  display: block;
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 600;
  color: #1890ff;
}

.existing-icon-box-small {
  width: 80px;
  height: 80px;
  border: 2px solid #d9d9d9;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  overflow: hidden;
}

.existing-icon-box-small img {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}

.submenu-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e4e7ed;
}

/* Submenu List */
.submenu-list-container {
  margin-top: 15px;
}

.submenu-empty {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
}

.submenu-empty i {
  font-size: 64px;
  color: #dcdfe6;
  margin-bottom: 15px;
}

.submenu-empty p {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 500;
  color: #606266;
}

.submenu-empty span {
  font-size: 13px;
  color: #909399;
}

.submenu-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.submenu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px;
  background: white;
  border: 2px solid #e4e7ed;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.submenu-item:hover {
  border-color: #409EFF;
  background: #ecf5ff;
  transform: translateX(5px);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
}

.submenu-item-order {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
}

.submenu-item-icon {
  width: 40px;
  height: 40px;
  background: #f5f7fa;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 20px;
  color: #909399;
}

.submenu-item-info {
  flex: 1;
  min-width: 0;
}

.submenu-item-label {
  margin: 0 0 4px 0;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.submenu-item-path {
  margin: 0;
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.submenu-item-actions {
  display: flex;
  /* gap: 2px; */
  flex-shrink: 0;
}

.submenu-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #EBEEF5;
}

.submenu-save-btn {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  border: none;
}

.submenu-save-btn:hover {
  background: linear-gradient(135deg, #2ed165 0%, #26e7c5 100%);
}

/* Slide Fade Transition */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.form-content::-webkit-scrollbar {
  width: 6px;
}

.form-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.form-content::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 10px;
}

.form-content::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

/* Input focus animation */
@keyframes inputFocus {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.4);
  }
  100% {
    box-shadow: 0 0 0 4px rgba(64, 158, 255, 0.1);
  }
}

/* Submenus Role Section in Set Role Dialog */
.submenus-role-section {
  margin-top: 30px;
  padding-top: 25px;
  border-top: 2px dashed #e4e7ed;
}

.submenus-role-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.submenus-role-header i {
  font-size: 20px;
  color: #409EFF;
}

.submenu-count-badge {
  margin-left: auto;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.submenus-role-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.submenu-role-item {
  padding: 20px;
  background: #fafbfc;
  border: 1px solid #e4e7ed;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.submenu-role-item:hover {
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: #c6e2ff;
}

.submenu-role-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e4e7ed;
}

.submenu-role-icon {
  width: 45px;
  height: 45px;
  border-radius: 10px;
  background: white;
  border: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.submenu-role-icon img {
  max-width: 85%;
  max-height: 85%;
  object-fit: contain;
}

.submenu-role-details {
  flex: 1;
  min-width: 0;
}

.submenu-role-label {
  margin: 0 0 4px 0;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.submenu-role-path {
  margin: 0;
  font-size: 12px;
  color: #909399;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.submenu-role-tags {
  flex-shrink: 0;
}

.submenu-roles-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.submenu-role-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: white;
  border: 2px solid #e4e7ed;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.submenu-role-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(64, 158, 255, 0.1), transparent);
  transition: left 0.5s ease;
}

.submenu-role-card:hover::before {
  left: 100%;
}

.submenu-role-card:hover {
  border-color: #409EFF;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  transform: translateY(-2px);
}

.submenu-role-card i:first-child {
  font-size: 18px;
  color: #909399;
  transition: all 0.3s ease;
}

.submenu-role-card span {
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.submenu-role-check {
  width: 20px;
  height: 20px;
  border: 2px solid #dcdfe6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.submenu-role-card.selected {
  background: linear-gradient(135deg, #e3f2fd 0%, #f0f9ff 100%);
  border-color: #409EFF;
}

.submenu-role-card.selected i:first-child {
  color: #409EFF;
}

.submenu-role-card.selected span {
  color: #303133;
  font-weight: 600;
}

.submenu-role-card.selected .submenu-role-check {
  background: #67C23A;
  border-color: #67C23A;
  animation: checkBounce 0.3s ease;
}

/* Kelola Dialog Styles */
.kelola-dialog-header {
  display: flex;
  align-items: center;
  gap: 15px;
}

.kelola-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #303133;
}

.kelola-subtitle {
  margin: 5px 0 0 0;
  font-size: 13px;
  color: #909399;
}

.kelola-content {
  padding: 10px 0;
  max-height: 75vh;
  overflow-y: auto;
}

.kelola-menu-card {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  margin-bottom: 20px;
  color: white;
}

.kelola-menu-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.kelola-menu-icon img {
  max-width: 85%;
  max-height: 85%;
  object-fit: contain;
}

.kelola-menu-details {
  flex: 1;
  min-width: 0;
}

.kelola-menu-label {
  margin: 0 0 6px 0;
  font-size: 20px;
  font-weight: 700;
  color: white;
}

.kelola-menu-path {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kelola-menu-tags {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.kelola-tabs {
  margin-top: 10px;
}

.kelola-tabs .el-tabs__header {
  margin-bottom: 20px;
}

.kelola-tabs .el-tabs__item {
  font-size: 15px;
  font-weight: 500;
  padding: 0 25px;
  height: 45px;
  line-height: 45px;
}

.kelola-tabs .el-tabs__item.is-active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.tab-icon-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e4e7ed;
}

.tab-icon-wrapper i {
  font-size: 20px;
  color: #409EFF;
}

.kelola-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #EBEEF5;
}

.kelola-save-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
}

.kelola-save-btn:hover {
  background: linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%);
  color: white;
}

.kelola-content::-webkit-scrollbar {
  width: 6px;
}

.kelola-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.kelola-content::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 10px;
}

.kelola-content::-webkit-scrollbar-thumb:hover {
  background: #909399;
}
</style>